import { render, staticRenderFns } from "./ViewProfilePage.vue?vue&type=template&id=07c3829c&scoped=true"
import script from "./ViewProfilePage.vue?vue&type=script&lang=js"
export * from "./ViewProfilePage.vue?vue&type=script&lang=js"
import style0 from "./ViewProfilePage.vue?vue&type=style&index=0&id=07c3829c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3829c",
  null
  
)

export default component.exports